import type { FormDataType } from "../types/form";
import { apiPaths } from "@/config/urls";

export interface SetBirthDateResponse {
  result: boolean;
  errorMsg?: string;
}

export interface SendActivationEmailResponse {
  debugMsg?: string;
  responseCode?: number;
  result: boolean;
  birthDateMissing?: boolean;
  value?: boolean;
}

export interface SendComplaintResponse {
  modal: string;
}

export async function sendUserBirthday(birthday: string): Promise<SetBirthDateResponse> {
  try {
    // Serwlety często oczekują parametrów formularza x-www-form-urlencoded
    const params = new URLSearchParams();
    params.append("birthDate", birthday); // birthday jest już w formacie YYYY-MM-DD

    const response = await fetch("/register/setBirthDate.servlet", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params.toString(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    console.error("Błąd podczas wysyłania daty urodzenia:", err);
    return { result: false, errorMsg: "Nie udało się zapisać daty urodzenia." };
  }
}

export async function sendActivationEmail(): Promise<SendActivationEmailResponse> {
  try {
    const response = await fetch("/register/sendActivationEmail.servlet", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();

  } catch (err) {
    console.error("Błąd podczas ponownej wysyłki maila aktywacyjnego:", err);
    return { 
      result: false, 
      debugMsg: "Błąd połączenia z serwerem.",
      value: false,
      responseCode: 500
      // birthDateMissing: false,
      // responseCode: 403
    };
  }
}

export async function sendReport(formData: FormDataType): Promise<{
  status: number;
  formData: FormDataType;
}> {
  try {
    const response = await fetch(apiPaths.REPORT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return {
      status: response.status,
      formData,
    };
  } catch (err) {
    console.error("Błąd wysyłania raportu:", err);
    return {
      status: 500,
      formData,
    }
  }
}

export async function sendComplaint(reason: string, code: string): Promise<SendComplaintResponse> {
  try {
    const response = await fetch(apiPaths.COMPLAINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ reason, code }),
    });

    if (!response.ok) {
      return { modal: "something_wrong" };
    }

    const data = await response.json();

    return { modal: data.modal || "something_wrong" };
  } catch (err) {
    return { modal: "something_wrong" };
  }
}